import { Button, makeStyles, MenuTriggerChildProps } from "@fluentui/react-components";
import { forwardRef } from "react";

interface IMenuHeaderProps extends MenuTriggerChildProps {
    label: string;
};

const useStyles = makeStyles({
    button: {
        padding: "10px",
        whiteSpace: "nowrap",
        minWidth: "auto"
    }
});

const MenuHeader = forwardRef<HTMLButtonElement, Partial<IMenuHeaderProps>>((props, ref) => {
    const styles = useStyles();

    return (
        <Button {...props} ref={ref} type="button" appearance="subtle" className={styles.button}>
            {props.label}
        </Button>
    );
});

export default MenuHeader;